<div class="window">
    <h3 class="msg">
        {{ message$ | async }}
    </h3>
</div>